// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__action-delete{color:#f83245}.text__discount-price{color:#3b3e66}.cart__items-list>span:first-child hr{display:none}.img-size{height:100px;max-height:-webkit-max-content;max-height:-moz-max-content;max-height:max-content}", ""]);
// Exports
module.exports = exports;
